<template v-if="loaded">
  <menu-dottorfarma
    v-if="user && user.dottorfarma && user.tipologia === 'professionista'"
    v-on:logging-out="logout"
    :nonletti="unseen"
    :nuoviConsulti="newCons"
    :verificato="verified"
    :has_anagrafica="anagrafica"
    v-on:reset="unflag"
    v-on:reset-consulti="unflagConsulti"
  ></menu-dottorfarma>
  <menu-professionista
    v-else-if="user && user.tipologia === 'professionista'"
    v-on:logging-out="logout"
    :nonletti="unseen"
    :nuoviConsulti="newCons"
    :verificato="verified"
    :has_anagrafica="anagrafica"
    v-on:reset="unflag"
    v-on:reset-consulti="unflagConsulti"
  ></menu-professionista>
  <menu-paziente
    v-else-if="user && user.tipologia === 'paziente'"
    v-on:logging-out="logout"
    :nonletti="unseen"
    :nuoviConsulti="newCons"
    :verificato="verified"
    :has_anagrafica="anagrafica"
    v-on:reset="unflag"
    v-on:reset-consulti="unflagConsulti"
  ></menu-paziente>
  <menu-paziente
    v-else-if="user && user.tipologia === 'admin'"
    v-on:logging-out="logout"
    :nonletti="unseen"
    :nuoviConsulti="newCons"
    :verificato="verified"
    :has_anagrafica="anagrafica"
    v-on:reset="unflag"
    v-on:reset-consulti="unflagConsulti"
  ></menu-paziente>
</template>
<script>
import MenuProfessionista from "./MenuProfessionista";
import MenuDottorfarma from "./MenuDottorfarma";
import MenuPaziente from "./MenuPaziente";
import * as io from "socket.io-client";
export default {
  name: "nav-bar",
  props: ["verificato_post", "has_anagrafica"],
  components: { MenuDottorfarma, MenuProfessionista, MenuPaziente },
  data() {
    return {
      user: null,
      unseen: 0,
      verified: true,
      anagrafica: true,
      loaded: false,
      newCons: 0,
    };
  },
  watch: {
    verificato_post: function(val) {
      if (val && val === true) {
        console.log(" watch verificato_post");
        this.verified = true;
        this.loaded = true;
      }
    },
    has_anagrafica: function(val) {
      if (val && val === true) {
        console.log(" watch has_anagrafica");
        // console.log("update menu");
        this.anagrafica = true;
        this.loaded = true;
      }
    },
  },
  sockets: {
    message: function(data) {
      this.unseen++;
      this.checkUnseen();
    },
    consulto(msg) {
      this.newCons++;
    },
  },
  methods: {
    logout() {
      this.$emit("logged-out");
    },
    // back() {
    //   this.$router.go(-1);
    // },
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then((res) => {
          this.user = res.data.data;
          if (!this.user.anagrafica) {
            this.anagrafica = false;
          }
          // console.log(this.user);
        })
        .catch((err) => {
          // this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
          if (err.response.status === 403) {
            this.verified = false;
          }
        });
    },
    checkUnseen() {
      var url = process.env.VUE_APP_VERSION + "messaggio/nonletti";
      this.$axios
        .get(url)
        .then((res) => {
          // console.log("messaggi non letti res", res.data.data);
          this.unseen = res.data.data;
        })
        .catch((err) => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    checkConsultiUnseen() {
      var url = process.env.VUE_APP_VERSION + "consulto/nonvisti";
      this.$axios
        .get(url)
        .then((res) => {
          this.newCons = res.data.data;
        })
        .catch((err) => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    unflag() {
      this.unseen = 0;
    },
    unflagConsulti() {
      this.newCons = 0;
    },
  },
  created() {
    this.fetchData();
    this.checkUnseen();
    this.checkConsultiUnseen();
  },
  mounted() {
    // this.sockets.on(
    //   "message",
    //   function(data) {
    //     console.log("player 2 joined game");
    //   }.bind(this)
    // );
  },
};
</script>
